import React, { Component } from "react";
import { Container, Nav, Navbar, Image } from "react-bootstrap";
import { NavLink } from "react-router-dom";
import { Dispatch } from "redux";
import { connect } from "react-redux";
import { IHeaderComponentState } from "../../interfaces/header.interface";
import AuthModal from "../../pages/Auth";
import logo from "../../assets/images/logo_header.png";
//import sampleAvatar from "../../assets/images/SampleAvatar.png";
import sampleAvatar from "../../assets/images/dummyImage.png";
import { logger } from "../../helper/Logger";
import { IRootState } from "../../interfaces";
import { LogOutRequest } from "../../action";
import { AppRoutes } from "../../config";
import { log } from "util";
import Avatar from "react-avatar";
import { ImageURL } from "../../config";
import { FrontendUrl } from "../../config";
// import avatarImage from "../../assets/images/avatar.svg";
class Header extends Component<any, any> {
  constructor(props: any) {
    super(props);
    this.state = {
      username: "",
      open: false,
      show: false,
      sidebar: false,
      searchbar: false,
      submenu: false,
      modalLabel: "login",
    };
  }
  componentDidMount = () => {
    // window.addEventListener('scroll', this.handleScroll);
    const firstName = localStorage.getItem("firstName")
      ? localStorage.getItem("firstName") || ""
      : "";
    console.log(firstName);
    this.setState({ username: firstName });
    if( document.getElementById('navbar-toggler')) {
    const button = document.getElementById('navbar-toggler')?.childNodes[0];

    button?.addEventListener('click', function handleClick(event) {
    console.log('toggler button clicked');
      //console.log(event);
      //console.log(event.target);
      document.querySelector('.full-app-wrap')?.classList.add("modal-container");    
      document.getElementById("mobile-menu-hover-info")?.setAttribute("style","display:block");

    });
    document.getElementById("mobile-menu-hover-info")?.setAttribute("style","display:none");
    document.querySelector('.full-app-wrap')?.classList.remove("modal-container");    

  }
  };
  componentDidUpdate = (prevProps: any) => {
    if (
      prevProps.loginReducer &&
      this.props.loginReducer &&
      this.props.loginReducer.isLoading !== prevProps.loginReducer.isLoading &&
      !this.props.loginReducer.error
    ) {
      this.setState({
        show: false,
      });
    }
  };
  // handleScroll = () => {
  //   const scrollPositionY = window.scrollY;
  //   //console.log(scrollPositionY);
  //   const header: HTMLElement | null = document.getElementById('mainHeader');
  //   if (header) {
  //     if (scrollPositionY >= 100) {
  //       header.classList.add('sticky');
  //     } else {
  //       header.classList.remove('sticky');
  //     }
  //   }
  // };
  componentWillUnmount = () => {
    // window.removeEventListener('scroll', this.handleScroll);
  };
  handleClose = () => {
    logger("calling............");
    this.setState({
      show: false,
      modalLabel: "login",
    });
  };
  // To handle login & forgot password modal
  handleShow = () => {
    this.setState({ show: true });
  };
  Closesidenav = () => {
    this.setState({ sidebar: false });
  };

  // To Handle search bar
  Closesearchbar = () => {
    this.setState({ searchbar: false });
  };
  Opensearchbar = () => {
    this.setState({ searchbar: true });
  };
  // To manage forgot password modal
  forgotShow = () => { 
    this.setState({ show: true, modalLabel: "forgot" });
  };
  resetShow = () => { 
    this.setState({ show: true, modalLabel: "reset" });
  };
  // // To manage login modal
  // showLoginModal = () => {
  //   this.setState({ show: true, modalLabel: 'login' });
  // };
  showsubmenu = () => {
    this.setState({ submenu: !this.state.submenu });
  };
  render() {
    const { show, modalLabel, mobileClass, mobileView } = this.state;
    const { loginReducer } = this.props;

    console.log("userImage",this.props.userImage);
    // const { profileReducer, activeKey } = this.props;
    // const { profileInfo } = profileReducer;
    //   const imgPath = profileInfo.imagePath;
    //  console.log(">>>>>>");
    return (
      <>
        <header className="header-area">          
            <Container fluid={true}>
              
              <div id="bannerImage">
                <div id="headerBlock">
                  <div className="toggleImage" style={{float:"left"}}>
                  <Navbar expand="lg" className="bg-body-tertiary">
                  <Navbar.Toggle aria-controls="basic-navbar-nav" id="navbar-toggler"/>
                  <Navbar.Collapse id="basic-navbar-nav">                    
                  </Navbar.Collapse>
                  </Navbar>
                  </div>               
                  <div className="floatLeft">                 
                  <span >
                    {this.props.location.pathname === AppRoutes.HOME ? (
                  ""
                ) : (     
                      <Image
                      id="image_banner"
                      className="cursor-pointer logo-height"
                      src={logo}
                    onClick={() => this.props.history.push("/welcome")}
                    />)}
                    </span>
                  </div>
                  
                  <div className="HeaderText">
                    <span className="welomeText">Welcome back</span>
                    <span className="nameText">{this.state.username}</span><br></br>                    
                    <span className="changePwdText cursor-pointer"
                    onClick={() => {
                      // window.location.reload();
                      localStorage.clear();
                      this.props.onLogout();
                    }}
                    >
                      
                      Log Out</span>
                  </div>
                  <div id="outerCircle">
                      <div id="inner">
                      {this.props.userImage ? (
                     <Image
                      width="60px" height="60px"
                              src={FrontendUrl+"uploads/"+`${this.props.userImage}`}
                            />
                          ) : (<Image
                          width="60px" height="60px" id="innerAvatar"
                                  src={sampleAvatar} /> )}
                      </div>
                  </div>
                </div>
              </div>

            </Container>
          
        </header>
      </>
    );
  }
}

const mapStateToProps: any = (state: IRootState) => ({
  loginReducer: state.loginReducer,
});

const mapDispatchToProps = (dispatch: Dispatch) => {
  return {
    onLogout: () => {
      dispatch(LogOutRequest());
    },
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(Header);

